import React, {useRef, useEffect} from 'react'
import './html-content.css'

/**
 * Processes raw-html-embed divs that store their content in an `html` attribute
 * and injects it as innerHTML so embeds (iframes, etc.) render correctly.
 */
function processHtmlEmbeds(container: HTMLElement) {
  const embeds = container.querySelectorAll('div.raw-html-embed[html]')
  embeds.forEach((el) => {
    const html = el.getAttribute('html')
    if (html) {
      el.removeAttribute('html')
      el.innerHTML = html
    }
  })
}

export default function HTMLContent(props: {
  className?: string
  children: string
  'aria-label'?: string
}) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      processHtmlEmbeds(ref.current)
    }
  })

  return (
    <div
      ref={ref}
      className={`html-content ${props.className ?? ''}`}
      dangerouslySetInnerHTML={{
        __html: props.children,
      }}
      aria-label={props['aria-label']}
    />
  )
}
